var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAudiSport = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 38,
  height: 12
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF",
  transform: "translate(.833 .167)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M8.255 8.75H1.667m6.588-2.448H0M8.255 3.75H1.667"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30.556,
  cy: 8.912,
  r: 2.338
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15.973,
  cy: 8.912,
  r: 2.338
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.316 9.583H18.198"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M13.79 9.71c-2.773 0-3.373-.96-3.373-.96V4.536l4.792-2.648S17.154.417 21.643.417c4.49 0 7.22 2.681 7.22 2.681l5.423 1.767s1.143.214 1.708 1.433c.25.541.256 1.308.256 2.131v1.154h-3.454"
}))));
export { SvgAudiSport as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLjgzMyAuMTY3KSIgc3Ryb2tlPSIjRkZGIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik04LjI1NSA4Ljc1SDEuNjY3bTYuNTg4LTIuNDQ4SDBNOC4yNTUgMy43NUgxLjY2NyIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjxjaXJjbGUgY3g9IjMwLjU1NiIgY3k9IjguOTEyIiByPSIyLjMzOCIvPjxjaXJjbGUgY3g9IjE1Ljk3MyIgY3k9IjguOTEyIiByPSIyLjMzOCIvPjxwYXRoIGQ9Ik0yOC4zMTYgOS41ODNIMTguMTk4Ii8+PHBhdGggZD0iTTEzLjc5IDkuNzFjLTIuNzczIDAtMy4zNzMtLjk2LTMuMzczLS45NlY0LjUzNmw0Ljc5Mi0yLjY0OFMxNy4xNTQuNDE3IDIxLjY0My40MTdjNC40OSAwIDcuMjIgMi42ODEgNy4yMiAyLjY4MWw1LjQyMyAxLjc2N3MxLjE0My4yMTQgMS43MDggMS40MzNjLjI1LjU0MS4yNTYgMS4zMDguMjU2IDIuMTMxdjEuMTU0aC0zLjQ1NCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvZz48L3N2Zz4=";